import e, { createContext as t, useContext as n, useState as r } from "react";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/view-switcher.tsx
var s = t(void 0), c = () => {
	let e = n(s);
	if (!e) throw Error("useViewSwitcher must be used within ViewSwitcherProvider");
	return e;
}, l = ({ children: e, defaultView: t = "CALENDAR" }) => {
	let [n, i] = r(t);
	return /* @__PURE__ */ a(s.Provider, {
		value: {
			currentView: n,
			setView: (e) => {
				i(e);
			},
			goToCalendarView: () => {
				i("CALENDAR");
			},
			goToMonthView: () => {
				i("MONTH");
			},
			goToYearView: () => {
				i("YEAR");
			}
		},
		children: e
	});
}, u = () => {
	let { goToCalendarView: t } = c();
	return e.useEffect(() => (console.log("ViewSwitcher mounted"), () => {
		t();
	}), []), null;
}, d = ({ children: e }) => /* @__PURE__ */ o(l, { children: [/* @__PURE__ */ a(u, {}), e] });
d.Consumer = ({ children: e }) => {
	let t = c();
	return /* @__PURE__ */ a(i, { children: e(t) });
};
export { d as ViewSwitcher, l as ViewSwitcherProvider, c as useViewSwitcher };

//# sourceMappingURL=view-switcher.js.map